<template>
    <div>
        <div class="expo">
            <RoomLink
                v-for="item in expoData.rooms"
                :info="item"
                :expoId="expoId"
                :key="item.id"
            ></RoomLink>
        </div>
        <div v-if="$store.state.user.loggedIn" @click="editRoom" class="circle grow-link abs-icon bot-right">
            <MdCreateIcon/><span class="tooltip">Edit Expo</span>
        </div>
    </div>
</template>

<script>
import MdCreateIcon from 'vue-ionicons/dist/md-create.vue'

import RoomLink from '../../RoomLink'
import { firestore } from '../../../../db'

const expos = firestore.collection('expos')

export default {
    name: 'ExpoMap',
    props: ['expoId'],
    components: {
        MdCreateIcon,
        RoomLink
    },
    data() {
        return {
            expoData: {}
        }
    },
    computed: {
        name() { return this.expoData.name }
    },
    methods: {
        editRoom() {
            this.$router.push('/editexpo/' + this.expoId)
        }
    },
    watch: {
        expoId: {
            immediate: true,
            handler(expoId) {
                this.$bind('expoData', expos.doc(expoId))
            }
        },
        name: {
            immediate: true,
            handler(name) {
                this.$store.dispatch('updatePageName', [{
                    name: name,
                    to: '/expo/' + this.expoId
                }])
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../expo.scss';
</style>